export default __webpack_public_path__ + "static/avenir-next-bold-c2863edb618388d8def39202852a2213.woff";